import React, { useState, useEffect } from "react";
import { FaAngleDown } from "react-icons/fa";
import './styles.css'

const dropdownStyles = {
  container: {
    position: "relative",
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    padding: "10px",
    borderRadius: "6px",
  },
  label: {
    fontSize: "14px",
    color: "#e1e1e1",
    fontWeight: "400",
  },
  button: {
    width: "100%",
    color: "#e1e1e1",
    padding: "12px 16px",
    border: "1px solid #314158",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  buttonAsPlacelholder: {
    width: "100%",
    color: "#e1e1e1",
    padding: "10px",
    border: "1px solid #314158",
    borderRadius: "8px",
    cursor: "pointer",
    fontSize: "14px",
    textAlign: "left",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  list: {
    position: "absolute",
    top: "110%",
    left: 0,
    right: 0,
    backgroundColor: "#1e1e1e",
    border: "1px solid #314158",
    borderRadius: "8px",
    overflow: "hidden",
    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
    zIndex: 10001,
    maxHeight: 0,
    opacity: 0,
    transition: "max-height 0.3s ease, opacity 0.3s ease",
  },
  listOpen: {
    maxHeight: "180px",
    opacity: 1,
    overflowY: 'scroll',
  },
  item: {
    padding: "12px 16px",
    cursor: "pointer",
    fontSize: "15px",
    color: "#fff",
  },
  itemHover: {
    backgroundColor: "#333",
  },
  icon: {
    transition: "transform 0.3s ease",
  },
};

const Dropdown = ({ label, placeholder, mandatory, items, onSelect, value }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [hovered, setHovered] = useState(null);
  const [selected, setSelected] = useState(value || null);

  useEffect(() => {
    setSelected(value || null);
  }, [value]);

  const validatedPlaceholder = placeholder ? placeholder : 'Selecione um item'

  const handleSelect = (item) => {
    setSelected(item);
    setIsOpen(false);
    if (onSelect) onSelect(item);
  };

  return (
    <div style={dropdownStyles.container}>
        {label && (<label style={dropdownStyles.label}>{mandatory ? label + " *" : label}</label>)}

        <div
            style={placeholder !== "" && placeholder !== undefined ? dropdownStyles.buttonAsPlacelholder : dropdownStyles.button}
            onClick={() => setIsOpen(!isOpen)}
        >
            {selected || validatedPlaceholder}
            <span
            style={{
                ...dropdownStyles.icon,
                transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
            }}
            >
              <FaAngleDown />
            </span>
        </div>

        <div
            style={{
            ...dropdownStyles.list,
            ...(isOpen ? dropdownStyles.listOpen : {}),
            }}
        >
            {items.map((item, index) => (
            <div
                key={index}
                style={{
                ...dropdownStyles.item,
                ...(hovered === index ? dropdownStyles.itemHover : {}),
                }}
                onMouseEnter={() => setHovered(index)}
                onMouseLeave={() => setHovered(null)}
                onClick={() => handleSelect(item)}
            >
                {item}
            </div>
            ))}
        </div>
    </div>
  );
};

export default Dropdown;